
import { useEffect, useState } from "react";

export default function Timer({ diffSecond, minuteVisible, secondVisible, onFinish }) {
	const [day, setDay] = useState(0);
	const [hour, setHour] = useState(0);
	const [minute, setMinute] = useState(0);
	const [second, setSecond] = useState(0);
	const [isFinished, setIsFinished] = useState(Math.floor(diffSecond) <= 0);
	let timer = undefined;
	let remainingSecond = Math.floor(diffSecond);

	useEffect(() => {
		if (remainingSecond <= 0) {
			setIsFinished(true);
			onFinish();
			return;
		}

		timer = setInterval(() => {
			if (remainingSecond <= 0) {
				onFinish();
				setIsFinished(true);
				setDay(0);
				setHour(0);
				setMinute(0);
				setSecond(0);
				clearInterval(timer);
				return;
			}
			updateDay(remainingSecond);
			updateHour(remainingSecond);
			updateMinute(remainingSecond);
			updateSecond(remainingSecond);
			remainingSecond--;
		}, 1000);
		return () => clearInterval(timer);
	}, []);

	function updateDay(remainingSecond) {
		const newDay = Math.floor(remainingSecond / (60 * 60 * 24));
		setDay(newDay);
	}

	function updateHour(remainingSecond) {
		let newHour = (remainingSecond % (60 * 60 * 24)) / (60 * 60);
		newHour = Math.floor(newHour);
		setHour(newHour);
	}

	function updateMinute(remainingSecond) {
		let newMinute = (remainingSecond % (60 * 60)) / 60;
		newMinute = Math.floor(newMinute);
		setMinute(newMinute);
	}

	function updateSecond(remainingSecond) {
		let newSecond = remainingSecond % 60;
		newSecond = Math.floor(newSecond);
		setSecond(newSecond);
	}

	if (isFinished) {
		return (
			<div className="font-Vazir-700 text-[12px] text-midGray">
				تمام شده
			</div>
		);
	}

	return (
		<div className="flex flex-row justify-center items-center gap-2">
			<div className="font-Vazir-700 text-[12px] gap-2 text-midGray flex">
				<div className="text-center">{day}</div>
				<div className="text-center font-Vazir-300">روز</div>
			</div>
			<div className="font-Vazir-700 text-[12px] gap-2 text-midGray flex">
				<div className="text-center">{hour}</div>
				<div className="text-center font-Vazir-300">ساعت</div>
			</div>
			{minuteVisible && (
				<div className="font-Vazir-700 text-[12px] gap-2 text-midGray flex">
					<div className="text-center">{minute}</div>
					<div className="text-center font-Vazir-300">دقیقه</div>
				</div>
			)}
			{secondVisible && (
				<div className="font-Vazir-700 text-[12px] gap-2 text-midGray flex">
					<div className="text-center">{second}</div>
					<div className="text-center font-Vazir-300">ثانیه</div>
				</div>
			)}
		</div>
	)
}
